"use client";
import { useEffect, useRef, useState } from "react";
import AboutUs from "./components/AboutUs";
import Footer from "./components/Footer";
import Gallery from "./components/Gallery";
import Mission from "./components/Mission";
import Navigation from "./components/Navigation";
import Serrvices from "./components/Serrvices";
import Specialize from "./components/Specialize";
import TeamMember from "./components/TeamMember";
import Timeline from "./components/Timeline";
import Value from "./components/Value";

export default function Page() {
  const [currentSection, setCurrentSection] = useState(""); // Lưu trữ section hiện tại
  const aboutUsRef = useRef(null);
  const servicesRef = useRef(null);
  const contactUsRef = useRef(null);
  useEffect(() => {
    const sections = [
      { name: "about-us", ref: aboutUsRef },
      { name: "services", ref: servicesRef },
      { name: "contact-us", ref: contactUsRef },
    ];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setCurrentSection(entry.target.id); // Cập nhật currentSection theo ID của phần tử đang xuất hiện
          }
        });
      },
      { threshold: 0.1 } // Khi 10% của phần tử xuất hiện trên màn hình
    );

    sections.forEach((section) => {
      if (section.ref.current) {
        observer.observe(section.ref.current);
      }
    });

    // Cleanup observer khi component unmount
    return () => {
      sections.forEach((section) => {
        if (section.ref.current) {
          observer.unobserve(section.ref.current);
        }
      });
    };
  }, []);
  const handleScrollToSection = (section) => {
    const sectionRefMap = {
      "about-us": aboutUsRef,
      services: servicesRef,
      "contact-us": contactUsRef,
    };

    const ref = sectionRefMap[section];
    if (section === "contact-us") {
      // Scroll to the bottom of the page for 'contact-us' section
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "end", // Aligns the 'contact-us' section to the bottom
        inline: "nearest",
      });
    } else {
      // Default scroll behavior for other sections
      const offset = 50;
      const elementPosition =
        ref.current.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;

      // Scroll smoothly to the adjusted position
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  return (
    <>
      <div className="w-full  bg-white font-beVietnamPro flex flex-col items-center">
        <Navigation
          currentSection={currentSection}
          handleScrollToSection={handleScrollToSection}
        />
        <div className="pt-[90px]">
          <div id="about-us" ref={aboutUsRef}>
            <div className="flex flex-col items-center">
              <AboutUs />
            </div>
            <Mission />
            <Timeline />
            <Value />
            <Specialize />
            <TeamMember />
          </div>
          <div className="flex flex-col items-center" id="services" ref={servicesRef}>
            <Serrvices />
          </div>

          <Gallery />
          <div id="contact-us" ref={contactUsRef}>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
